import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

const MORE = 'more';
const LESS = 'less';

function featureSelected({
    selectedFeatures,
    selectedFeaturesBefore,
    totalFeatures,
    totalTrips,
}) {
    const property = {
        num_trips: totalTrips,
        selected_features: selectedFeatures,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'amenities',
        property,
    });

    amplitude.track('search_filtered', {
        filter_list_selected_count: selectedFeatures.length,
        filter_list_total_count: totalFeatures,
        filter_type: 'amenities',
        results_count_before: totalTrips,
        updated_from: selectedFeaturesBefore,
        updated_to: selectedFeatures,
    });
}

function moreButtonClicked(action = MORE) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: `${action}_amenities`,
    });
}

export default {
    featureSelected,
    LESS,
    MORE,
    moreButtonClicked,
};
